'use strict';

import angular from 'angular';
import currencySymbolModule from '../services/currency_symbol.service';

const priceFilter = ($filter, currencySymbol) => {
  'ngInject';

  const currencyFilter = $filter('currency');

  return (amount, currency, decimalPoints = 2) => {
    return currencyFilter(amount, currencySymbol(currency), decimalPoints);
  };
};

const dependencies = [
  currencySymbolModule
];

export default angular
  .module('filters.membershipPrice', dependencies)
  .filter('price', priceFilter)
  .name;



// WEBPACK FOOTER //
// ./app/src/filters/price.filter.js